import { createApp, reactive, ref } from 'vue'

import Form from './submission_form/form'
import NewForm from './submission_form/new_form.vue'
import DownloadButton from './elements/download_button'
import ToggleSubmit from './elements/toggle_submit'
import OtherActions from './submission_form/other_actions.vue'
import PdfComments from './components/submission/pdf_comment_form.vue'

const safeRegisterElement = (name, element, options = {}) => !window.customElements.get(name) && window.customElements.define(name, element, options)

safeRegisterElement('download-button', DownloadButton)
safeRegisterElement('toggle-submit', ToggleSubmit)
safeRegisterElement('submission-form', class extends HTMLElement {
  connectedCallback () {
    this.appElem = document.createElement('div')

    this.app = createApp(Form, {
      submitter: JSON.parse(this.dataset.submitter),
      canSendEmail: this.dataset.canSendEmail === 'true',
      previousSignatureValue: this.dataset.previousSignatureValue,
      userSignatures: JSON.parse(this.dataset.userSignatures || '{}'),
      userInitials: JSON.parse(this.dataset.userInitials || '{}'),
      goToLast: this.dataset.goToLast === 'true',
      isDemo: this.dataset.isDemo === 'true',
      attribution: this.dataset.attribution !== 'false',
      scrollPadding: this.dataset.scrollPadding || '-80px',
      dryRun: this.dataset.dryRun === 'true',
      expand: ['true', 'false'].includes(this.dataset.expand) ? this.dataset.expand === 'true' : null,
      withConfetti: this.dataset.withConfetti !== 'false',
      withDisclosure: this.dataset.withDisclosure === 'true',
      withTypedSignature: this.dataset.withTypedSignature !== 'false',
      authenticityToken: document.querySelector('meta[name="csrf-token"]')?.content,
      rememberSignature: this.dataset.rememberSignature === 'true',
      values: reactive(JSON.parse(this.dataset.values)),
      completedButton: JSON.parse(this.dataset.completedButton || '{}'),
      withQrButton: true,
      completedMessage: JSON.parse(this.dataset.completedMessage || '{}'),
      completedRedirectUrl: this.dataset.completedRedirectUrl,
      attachments: reactive(JSON.parse(this.dataset.attachments)),
      fields: JSON.parse(this.dataset.fields)
    })

    this.app.mount(this.appElem)

    this.appendChild(this.appElem)
  }

  disconnectedCallback () {
    this.app?.unmount()
    this.appElem?.remove()
  }
})
safeRegisterElement('new-submission-form', class extends HTMLElement {
  connectedCallback () {
    this.appElem = document.createElement('div')

    this.app = createApp(NewForm, {
      submitter: JSON.parse(this.dataset.submitter),
      canSendEmail: this.dataset.canSendEmail === 'true',
      previousSignatureValue: this.dataset.previousSignatureValue,
      userSignatures: JSON.parse(this.dataset.userSignatures || '{}'),
      userInitials: JSON.parse(this.dataset.userInitials || '{}'),
      goToLast: this.dataset.goToLast === 'true',
      isDemo: this.dataset.isDemo === 'true',
      attribution: this.dataset.attribution !== 'false',
      scrollPadding: this.dataset.scrollPadding || '-80px',
      dryRun: this.dataset.dryRun === 'true',
      expand: ['true', 'false'].includes(this.dataset.expand) ? this.dataset.expand === 'true' : null,
      withConfetti: this.dataset.withConfetti !== 'false',
      withDisclosure: this.dataset.withDisclosure === 'true',
      withTypedSignature: this.dataset.withTypedSignature !== 'false',
      authenticityToken: document.querySelector('meta[name="csrf-token"]')?.content,
      rememberSignature: this.dataset.rememberSignature === 'true',
      values: reactive(JSON.parse(this.dataset.values)),
      completedButton: JSON.parse(this.dataset.completedButton || '{}'),
      withQrButton: true,
      completedMessage: JSON.parse(this.dataset.completedMessage || '{}'),
      completedRedirectUrl: this.dataset.completedRedirectUrl,
      attachments: reactive(JSON.parse(this.dataset.attachments)),
      fields: JSON.parse(this.dataset.fields),
      submissionId: this.dataset.submissionId || '',
      submissionSlug: this.dataset.submissionSlug || '',
      templateId: this.dataset.templateId || ''
    })

    this.app.mount(this.appElem)

    this.appendChild(this.appElem)
  }

  disconnectedCallback () {
    this.app?.unmount()
    this.appElem?.remove()
  }
})

safeRegisterElement('other-actions', class extends HTMLElement {
  connectedCallback () {
    this.appElem = document.createElement('div')
    this.app = createApp(OtherActions, {
      class: this.getAttribute('class')
    })

    this.app.mount(this.appElem)

    this.appendChild(this.appElem)
  }

  disconnectedCallback () {
    this.app?.unmount()
    this.appElem?.remove()
  }
})

window.commentMode = ref(false)

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-vue-comment]').forEach((el) => {
    const documentUuid = el.getAttribute('data-document-uuid')
    const submitters = el.getAttribute('data-submitters')
    const pageIndex = parseInt(el.getAttribute('data-page-index'), 10)
    const submissionSlug = el.getAttribute('data-submission-slug')
    const currentUserId = parseInt(el.getAttribute('data-current-user-id'), 10)

    const app = createApp(PdfComments, {
      documentUuid,
      pageIndex,
      submissionSlug,
      currentUserId,
      commentMode: window.commentMode,
      submitters // pass the shared ref
    })
    app.mount(el)
  })
})
